import $ from 'cash-dom';
import animate from './animate';

let instance = null;

class AnimatedReadMore {
	constructor() {
		if (instance) {
			return instance;
		}

		instance = this;
	}

	static getInstance() {
		if (!instance) {
			instance = new AnimatedReadMore();
		}

		return instance;
	}

	init() {
		$(function () {
			$('.read-more-container .animated-read-more').on('click', readMoreHandler);
			$('.read-more-container .animated-read-less').on('click', readLessHandler);
			$('.read-more-content .animated-read-less').on('click', readLessHandler);

			$(document).on('filters-change', function () {
				const $editorsReadMore = $('.editor-choice .read-more-container .animated-read-more');
				const $editorsReadLess = $('.editor-choice .read-more-container .animated-read-less');

				$editorsReadMore.off('click', readMoreHandler);
				$editorsReadLess.off('click', readLessHandler);
				$editorsReadMore.on('click', readMoreHandler);
				$editorsReadLess.on('click', readLessHandler);
			});

			function readMoreHandler(e) {
				e.preventDefault();

				const $currentReadMore = $(this);
				const isPgResultsPage = $('main.results-page').length
				let isInsideFilter = false;
				let isBulk = $currentReadMore.hasClass('bulk-read-more-control');

				let $currentElementHolder = isBulk ?
					$currentReadMore.closest('.bulk-read-more-container') :
					$currentReadMore.closest('.ppc-single-vendor');

				if (!$currentElementHolder.length) {
					$currentElementHolder = $currentReadMore.closest('.read-more-item');
				}

				if (!$currentElementHolder.length) {
					$currentElementHolder = $currentReadMore.closest('.filters-holder');
					isInsideFilter = true;
				}
				const $readMoreContent = isPgResultsPage ?
					$currentElementHolder.find('.read-more-content.mobile') : $currentElementHolder.find('.read-more-content');
				const $readMoreContainer = $currentElementHolder.find('.read-more-container');

				if (!isInsideFilter) {
					$readMoreContent.addClass('open');
					if (isBulk && $readMoreContent.length > 1) {
						$readMoreContent.each((i, contentHolder) => {
							animate.slideDown(contentHolder, 200);
						});
					} else {
						const contentHolder = $readMoreContent.get(0);
						animate.slideDown(contentHolder, 200);
					}
				}

				$readMoreContainer.addClass('open');
				$readMoreContainer.closest('.read-more-holder').addClass('open');

				if (!isInsideFilter) {
					const actionName = $currentReadMore.data('action-name')
						? $currentReadMore.data('action-name')
						: 'read_more_open';

					if (typeof GAEvents !== 'undefined') {
						GAEvents.sendEvent(
							"PPC",
							actionName,
							"Read More Open"
						);
					}
				}
			}

			function readLessHandler(e) {
				e.preventDefault();

				const $currentReadLess = $(this);
				const isPgResultsPage = $('main.results-page').length
				let isInsideFilter = false;
				let isBulk = $currentReadLess.hasClass('bulk-read-more-control');

				let $currentElementHolder = isBulk ?
					$currentReadLess.closest('.bulk-read-more-container') :
					$currentReadLess.closest('.ppc-single-vendor');

				if (!$currentElementHolder.length) {
					$currentElementHolder = $currentReadLess.closest('.read-more-item');
				}

				if (!$currentElementHolder.length) {
					$currentElementHolder = $currentReadLess.closest('.splide-ppc-single-vendor');
				}
				if (!$currentElementHolder.length) {
					$currentElementHolder = $currentReadLess.closest('.filters-holder');
					isInsideFilter = true;
				}
				const $readMoreContent = isPgResultsPage ?
					$currentElementHolder.find('.read-more-content.mobile') : $currentElementHolder.find('.read-more-content');
				const $readMoreContainer = $currentElementHolder.find('.read-more-container');

				if (!isInsideFilter) {
					setTimeout(() => {
						$readMoreContent.removeClass('open');
					}, 201);

					if (isBulk && $readMoreContent.length > 1) {
						$readMoreContent.each((i, contentHolder) => {
							animate.slideUp(contentHolder, 200);
						});
					} else {
						const contentHolder = $readMoreContent.get(0);
						animate.slideUp(contentHolder, 200);
					}
				}

				$readMoreContainer.removeClass('open');
				$readMoreContainer.closest('.read-more-holder').removeClass('open');

				if (!isInsideFilter) {
					const actionName = $currentReadLess.data('action-name')
						? $currentReadLess.data('action-name')
						: 'read_more_close';

					if (typeof GAEvents !== 'undefined') {
						GAEvents.sendEvent(
							"PPC",
							actionName,
							"Read More Close"
						);
					}
				}
			}
		});
	}
}

export default AnimatedReadMore;